import axios from 'axios';

import { DELETE_PHOTO_WIFI_POINT_API_URL, GET_COUNT_WIFI_POINT_PHOTO_API_URL, GET_PHOTO_WIFI_POINT_API_URL, GET_WIFI_MODEL_API_URL, GET_WIFI_TYPE_API_URL, UPLOAD_WIFI_POINT_PHOTO_API_URL } from '../../Optics/OpticApiConfig';


         //загрузка model WiFi
        export const loadingModelWifiData = async () => {
            try {
                const token = localStorage.getItem('token');
                const resultModel = await axios.get(GET_WIFI_MODEL_API_URL, {
                    headers:{
                        'Authorization': `Bearer ${token}` 
                      } 
                });
                return resultModel.data;
            } catch (error) {
               // console.error("Error fetching Coupling data:", error);
                throw error;
            }
        };

          //загрузка type WiFi
        export const loadingTypeWifiData = async () => {
            try {
                const token = localStorage.getItem('token');
                const result = await axios.get(GET_WIFI_TYPE_API_URL, {
                    headers:{
                        'Authorization': `Bearer ${token}` 
                      } 
                });
                return result.data;
            } catch (error) {
               // console.error("Error fetching Coupling data:", error);
                throw error;
            }
        };

        // Формат ip адресса для инпута
        export const ValidateAndFormatIp = (value) => {

            value = value.replace(/[^0-9.]/g, "");

            // Разбиваем на блоки
            const parts = value.split(".");

            // Ограничиваем по правилам IP
            const validParts = parts
                .slice(0, 4) // максимум 4 блока
                .map((part) => {
                if (part === "") return ""; // позволяем вводить неполные блоки
                let num = parseInt(part, 10);
                if (isNaN(num)) return "";
                if (num > 255) num = 255; // не больше 255
                return String(num);
                });

            return validParts.join(".");
        };

        // Формат MAC адресса для инпута
        export const ValidateAndFormatMac = (value) => {
            value = value.replace(/[^0-9a-fA-F]/g, "").toUpperCase();

            // Разбиваем по 2 символа
            const pairs = value.match(/.{1,2}/g) || [];

            // Ограничиваем до 6 пар
            const validPairs = pairs.slice(0, 6);

            return validPairs.join(":");
        };


         // количество фото WifiPoint
        export const fetchWifiPointPhotoCount = async (wifiPointId) => {
          const token = localStorage.getItem('token');
        
          try {
            const response = await fetch(`${GET_COUNT_WIFI_POINT_PHOTO_API_URL}?id=${wifiPointId}`, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
        
            if (response.ok) {
              const count = await response.json();
              return count; 
            } else {
              console.error("Ошибка ответа сервера:", response.statusText);
              return null; 
            }
          } catch (error) {
            console.error("Ошибка при получении количества файлов:", error);
            return null; 
          }
        };

         // Функция для загрузки фото WifiPoint на сервер
          export const uploadWifiPointImage = async (file, id, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, user) => {
           
            const token = localStorage.getItem('token');
              if (!token) {
                  console.log('Ошибка! Токен не найден');
                  return;
              }
        
            setFileName(file.name);
            setIsFileUploaded(true);
          
            const formData = new FormData();
            formData.append('file', file);
            formData.append('id', id);
            formData.append('user', user);
          
            try {
              const response = await fetch(UPLOAD_WIFI_POINT_PHOTO_API_URL, {
                method: 'POST',
                body: formData,
                headers: {
                  'Authorization': `Bearer ${token}` 
                }
              });
          
              const textResult = await response.text();
              try {
                const result = JSON.parse(textResult);
                if (response.ok) {
                  setUploadMessage(result.message);
          
                  // После успешной загрузки фото загружаем обновленный список изображений
                  await loadWifiPointImagesFromServer(id, setServerImageUrls, setUploadMessage);
                } else {
                  setUploadMessage('Ошибка загрузки файла: ' + result.message);
                }
              } catch (parseError) {
                setUploadMessage('Ошибка загрузки файла: ' + textResult);
              }
            } catch (error) {
              setUploadMessage('Ошибка загрузки файла: ' + error.message);
            }
          };

          // Функция загрузки фото с сервера WifiPoint
          export const loadWifiPointImagesFromServer = async (id, setServerImageUrls, setUploadMessage) => {
            const token = localStorage.getItem('token');
            if (!token) {
                console.log('Ошибка! Токен не найден');
                return;
            }
              try {
                const response = await fetch(`${GET_PHOTO_WIFI_POINT_API_URL}?id=${id}`, { 
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                  }
                });
            
                if (!response.ok) {
                  throw new Error('Ошибка при загрузке файлов с сервера.');
                }
            
                const imageList = await response.json();
            
                if (imageList.length === 0) {
                  setUploadMessage('Файлов не найдены.');
                  setServerImageUrls([]);
                  return;
                }
            
                const imageUrls = imageList.map(image => {
                  const url = `data:${image.contentType};base64,${image.fileContent}`;
                  return { url, fileName: image.fileName };
                });
            
                setServerImageUrls(imageUrls);
                setUploadMessage('');
              } catch (error) {
                setUploadMessage('Ошибка загрузки файлов с сервера: ' + error.message);
              }
            };

            // Функция для удаления фото Wifi Point на сервере
            export const deleteWifiPointImage = async (fileName, id, setServerImageUrls, setUploadMessage) => {
              
              const token = localStorage.getItem('token');
                  if (!token) {
                      console.log('Ошибка! Токен не найден');
                      return;
                  }
            
                try {
                  const response = await fetch(`${DELETE_PHOTO_WIFI_POINT_API_URL}?id=${id}&fileName=${fileName}`, {
                    method: 'DELETE',
                    headers: {
                      'Authorization': `Bearer ${token}` 
                    }
                  });
              
                  const result = await response.json();
                  if (response.ok) {
                    setUploadMessage(result.message);
                    // Обновляем список изображений
                    await loadWifiPointImagesFromServer(id, setServerImageUrls, setUploadMessage);
                  } else {
                    setUploadMessage('Ошибка удаления файла: ' + result.message);
                  }
                } catch (error) {
                  setUploadMessage('Ошибка удаления файла: ' + error.message);
                }
              };

  
 





 